import { Validator } from 'vee-validate'
import Store from '@/store/store'
import configType from '@/store/type/configType'
import dayjs from '@/plugins/date'
import {
    validateDeliverooUrl,
    validateDeliverooPickup,
} from '@/validators/deliverooUrl'
import { isVatNumber, isCompanyNumber } from '@/validators/ukCompanyIds'

const periodRegex = /^([0-1][0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/

Validator.extend('period-hour-format', {
    getMessage: () => 'Invalid.',
    validate: (value) => {
        return !(!periodRegex.test(value.from) || !periodRegex.test(value.to))
    },
})

Validator.extend('period-from-lt-to', {
    getMessage: () => 'Invalid.',
    validate: (value) => {
        return value.from <= value.to
    },
})

Validator.extend('period-overlap', {
    getMessage: () => 'Invalid.',
    validate: (value, args) => {
        let isValid = true

        args.periods.forEach((period, index) => {
            if (index === args.index) {
                return
            }

            if (period.from > value.from && period.from < value.to) {
                isValid = false
            }

            if (period.to > value.from && period.to < value.to) {
                isValid = false
            }

            if (period.from === value.from && period.to === value.to) {
                isValid = false
            }
        })

        return isValid
    },
})

// libphonenumber's metadata is a large part of the app bundle; it loads with the first phone
// field that is validated instead of with every page (tasks#211)
Validator.extend('phonenumber', {
    getMessage: () => 'Invalid.',
    validate: (value) =>
        import('libphonenumber-js').then(({ parseNumber, isValidNumber }) => {
            const defaultCountry =
                Store.getters[configType.getters.CURRENCY_LOCALE]
                    .toUpperCase()
                    .split('-')[1] || 'GB'

            const parsed = parseNumber(value, {
                extended: true,
                defaultCountry,
            })
            return isValidNumber(parsed)
        }),
})

Validator.extend('dateafter', {
    getMessage: () => 'Invalid.',
    validate: (value) => {
        return value >= dayjs().format('YYYY-MM-DD') ? true : false
    },
})

Validator.extend('space', {
    getMessage: () => 'Invalid.',
    validate: (value) => {
        return value.toString().charAt(0) == ' ' ? false : true
    },
})

Validator.extend('invoice-sum', {
    getMessage: () => 'Invalid.',
    validate: (value, args) => {
        let sum = 0
        args.forEach((arg) => {
            sum += parseFloat(arg)
        })

        return sum.toFixed(2) === parseFloat(value).toFixed(2)
    },
})

// Messages: validations.messages.deliveroo-url / deliveroo-pickup (vee-validate i18n driver, rootKey "validations").
Validator.extend('deliveroo-url', {
    getMessage: () => 'Invalid.',
    validate: (value) => validateDeliverooUrl(value),
})

// Params: [pickup latitude, pickup longitude] — a param change re-validates the field.
Validator.extend('deliveroo-pickup', {
    getMessage: () => 'Invalid.',
    validate: (value, args) => validateDeliverooPickup(value, args),
})

// a company's contract terms (tasks#211). Messages: validations.messages.uk-vat-number / uk-company-number.
Validator.extend('uk-vat-number', {
    getMessage: () => 'Enter the 9 digits of the VAT number, e.g. 447249235.',
    validate: (value) => isVatNumber(value),
})

Validator.extend('uk-company-number', {
    getMessage: () =>
        'Enter the 8-character Companies House number, e.g. 01234567 or SC123456.',
    validate: (value) => isCompanyNumber(value),
})
